<script lang="ts" setup>
import type { EsProduct } from '~layers/types/elastic'
import type { StoreStockStatusFragment } from '#graphql-operations'

export interface Props {
  product: EsProduct
  storeStock: StoreStockStatusFragment
  label?: string
}
defineProps<Props>()
const { openFor } = useReservationFormDialog()
</script>

<template>
  <button
    class="product-item__reservation-button"
    @click="openFor(product, storeStock)"
  >
    <span>{{ label || $t('Reserve this product') }}</span>
  </button>
</template>

<style src="~layers/components/Product/ReservationButton.css" />
